import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AppBarCustom from "../component/AppBar";
import {
  CheckCircleOutlineOutlined,
  DeleteRounded,
  ErrorOutlineOutlined,
  SearchRounded,
  UploadRounded,
} from "@mui/icons-material";
import React from "react";
import TableCustom from "../component/tableCustom";
import axios from "axios";
import Api from "../api/RestApi.json";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
export default function UploadPage(params) {
  const theme = useTheme();
  const goTo = useNavigate();

  const { state } = useLocation();
  const { data } = state;
  const initialData = params.data.filter(
    (item) => item.kategori == data.kategori && item.id_foreign == data.id
  );
  const initialRow = initialData.length;

  const [row, setRow] = React.useState(initialData);

  const [id_foreign, setId_foreign] = React.useState(data.id);
  const [kategori, setKategori] = React.useState(data.kategori);
  const [file, setFile] = React.useState(null);

  const handleImagesUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const columns = [
    {
      field: "nomor",
      headerName: "No",
      flex: 1,
      minWidth: 20,
    },
    // {
    //   field: "id",
    //   headerName: "ID",
    //   flex: 1,
    //   minWidth: 30,
    // },
    // {
    //   field: "id_foreign",
    //   headerName: "ID_Foreign",
    //   flex: 1,
    //   minWidth: 30,
    // },
    {
      field: "nama",
      headerName: "Nama File",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "tipe",
      headerName: "Tipe",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "ukuran",
      headerName: "Ukuran",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "view",
      headerName: "Tampilkan",
      flex: 2,
      minWidth: 100,

      renderCell: (params) => {
        return (
          <Tooltip title="Buka Gambar">
            <IconButton
              href={Api.src + "/" + params.row.nama}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SearchRounded color="primary" />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "delete",
      headerName: "Hapus",
      flex: 2,
      minWidth: 100,

      renderCell: (params) => {
        return (
          <Tooltip title="Hapus Gambar">
            <IconButton
              onClick={(e) => {
                deletePost(params.row.id);
              }}
            >
              <DeleteRounded color="error" />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const [uploadComplete, setUploadComplete] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const [uploadError, setUploadError] = React.useState(null);
  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const deletePost = async (id) => {
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    try {
      var response = "";
      response = await axios.delete(Api.file + "/" + id);
      if (response !== "") {
        setDeleteStatus("Data ID-" + id + " Berhasil dihapus");
        setRow(row.filter((item) => item.id !== id));
      }
      // console.log(response.data);
    } catch (error) {
      // console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
      goTo(0);
    }
  };

  const storePost = async (event) => {
    event.preventDefault();
    setUploadProgress(0);
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    const formData = new FormData();
    const nameFile = Date.now() + "_" + file.name;
    formData.append("id_foreign", id_foreign);
    formData.append("kategori", kategori);
    formData.append("file", file, nameFile);
    formData.append("tipe", event.target.tipe.value);
    formData.append("ukuran", file.size);
    try {
      var response = "";
      response = await axios.post(Api.file, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);

          if (row.length > 0) {
            setRow((rowData) => [
              ...rowData,
              {
                id: rowData.length > 0 ? rowData[rowData.length - 1].id + 1 : 1,
                id_foreign: id_foreign,
                nama: nameFile,
                kategori: kategori,
                tipe: formData.get("tipe"),
                ukuran: file.size,
              },
            ]);
          }
        },
      });
      setUploadComplete(true);
      // goTo("/potensi");
      if (row.length == 0) {
        goTo(0);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadError("File gagal di Upload. Tolong ulangi kembali.");
    }
  };


  const [link, setLink] = React.useState('');

  const storeLink = async (event) => {
    event.preventDefault();

    var id = "";
    if (data.kategori == "Potensi") {
      id = "100" + data.id;
    } else if (data.kategori == "Peluang") {
      id = "200" + data.id;
    } else if (data.kategori == "Infrastruktur") {
      id = "300" + data.id;
    }
    const formData = {
      id: id,
      nama: data.kategori+'-'+data.id,
      deskripsi: link,
      susunan: "-",
    };

    var responseData = null;
    try {
      responseData = await axios.post(Api.komponen, formData);
      goTo(0);
    } catch (error) {
      console.error("Error add Data: ", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        minWidth: "100%",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected={kategori} />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: 2 }}
            align="left"
          >
            Upload File {data.kategori}
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={(e) => {
              goTo("/" + data.kategori);
              if (row.length !== initialRow) {
                goTo(0);
              }
            }}
          >
            Kembali
          </Button>
        </Stack>
        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <Grid
            container
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            padding={2}
            justifyContent={"space-around"}
            alignItems={"center"}
          >
            <Grid>
              <Typography variant="h5" fontWeight={"bold"} align="left">
                Gambar
              </Typography>
              <form onSubmit={storePost}>
                <input type="text" name="tipe" value="Image" hidden readOnly />
                <Box
                  py={2}
                  component="input"
                  type="file"
                  name="file"
                  accept="image/*"
                  onChange={handleImagesUpload}
                  required
                />
                <br />
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  startIcon={<UploadRounded />}
                >
                  Upload
                </Button>
              </form>
            </Grid>

            <Grid>
              {" "}
              <Typography variant="h5" fontWeight={"bold"} align="left">
                Dokumen
              </Typography>
              <form onSubmit={storePost}>
                <input
                  type="text"
                  name="tipe"
                  value="Document"
                  hidden
                  readOnly
                />
                <Box
                  py={2}
                  component="input"
                  type="file"
                  name="file"
                  accept="application/*"
                  onChange={handleImagesUpload}
                  required
                />
                <br />
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  startIcon={<UploadRounded />}
                >
                  Upload
                </Button>
              </form>
            </Grid>
          </Grid>

          {uploadProgress > 0 && (
            <Typography variant="body2" color="textSecondary">
              Upload Progress: {uploadProgress}%
            </Typography>
          )}
          {uploadComplete && (
            <Typography
              variant="body2"
              color="success.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              Upload Complete <CheckCircleOutlineOutlined sx={{ ml: 1 }} />
            </Typography>
          )}
          {uploadError && (
            <Typography
              variant="body2"
              color="error"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {uploadError} <ErrorOutlineOutlined sx={{ ml: 1 }} />
            </Typography>
          )}

          {row.filter(
            (item) =>
              item.kategori == data.kategori && item.id_foreign == data.id
          ).length > 0 && (
            <TableCustom
              column={columns}
              row={row.map((item, index) => ({
                nomor: index + 1,
                id: item.id,
                id_foreign: data.id,
                nama: item.nama,
                tipe: item.tipe,
                ukuran: (item.ukuran / 1000000).toFixed(2) + " MB",
              }))}
            />
          )}
          {deleteStatus && (
            <Typography
              variant="body2"
              color="error.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
